import { Heading } from '@chakra-ui/react'
import { getSalesMetricsByUsers } from 'api'
import { UiCard, UiCardHeader, UiCardBody, UiDataTable } from 'components/common'
import { useAppContext } from 'hooks/useAppContext'
import { useEffect, useState } from 'react'
import { useImmer } from 'use-immer'
import { SALES_USERS_REVENUE_COLUMNS } from './data'
import { useDebouncedCallback } from 'use-debounce'

export const SalesUsersRevenueTable = (props) => {
  const { createToast } = useAppContext()
  const [isLoading, setIsLoading] = useState(false)
  const [salesUsers, setSalesUsers] = useState([])
  const [rows, setRows] = useState([])
  const [tableConfig, setTableConfig] = useImmer({
    curPage: 1,
    totalPages: 1,
    totalRecords: 0,
    itemsPerPage: 10,
    search: '',
    orderBy: {
      key: 'name',
      direction: 'asc'
    }
  })

  useEffect(() => {
    const load = async () => {
      try {
        const response = await getSalesMetricsByUsers()
        setSalesUsers(response)
      } catch (err) {
        createToast('error', 'Error', 'Failed to load sales users with metrics.')
      }
    }
    load()
  }, [])

  const filter = () => {
    setIsLoading(true)
    const searchedData = salesUsers.filter(v => v.name.includes(tableConfig.search))
    const sortedData = searchedData.sort((a, b) => {
      const direction = tableConfig.orderBy.direction === 'asc' ? 1 : -1
      return a[tableConfig.orderBy.key] < b[tableConfig.orderBy.key]
        ? 1 * direction
        : (a[tableConfig.orderBy.key] === b[tableConfig.orderBy.key] ? 0 : -1 * direction)
    })
    const dataForPage = sortedData.slice((tableConfig.curPage - 1) * tableConfig.itemsPerPage, tableConfig.curPage * tableConfig.itemsPerPage)
    setRows(dataForPage)
    setIsLoading(false)
  }

  const debouncedFilter = useDebouncedCallback(filter, 400)

  useEffect(() => {
    debouncedFilter()
  }, [salesUsers, tableConfig.curPage, tableConfig.itemsPerPage, tableConfig.search, tableConfig.orderBy.key, tableConfig.orderBy.direction])

  useEffect(() => {
    setTableConfig(draft => {
      draft.totalRecords = salesUsers.length || 0
      draft.totalPages = Math.ceil(draft.totalRecords / draft.itemsPerPage)
    })
  }, [salesUsers])

  return (
    <UiCard borderRadius={0} {...props}>
      <UiCardHeader bg="gray.500" p={4}>
        <Heading color="white" size="sm">Sales Users Revenue</Heading>
      </UiCardHeader>
      <UiCardBody p={8}>
        <UiDataTable
          tableConfig={tableConfig}
          updateTableConfig={setTableConfig}
          rows={rows}
          rowKey="id"
          columns={SALES_USERS_REVENUE_COLUMNS}
          isLoading={isLoading}
        />
      </UiCardBody>
    </UiCard>
  )
}
